import {Page} from "../../../Common/Component/Page/Page";
import {Col, Row} from "react-bootstrap";
import {useContext} from "react";
import {UserContext} from "../../../Common/Context/UserContext";
import UserDetailsPasswordForm from "./Component/UserDetailsPasswordForm";
import UserProfileDetails from "./Component/UserProfileDetails";

const CurrentUserPage = () => {

    const {currentUser} = useContext(UserContext);

    return (<Page>
            <Row>
                <Col>
                    <UserProfileDetails currentUser={currentUser}/>
                </Col>
            </Row>
            <Row>
                {// <Col sm={12} md={6}>
                  //  <UserDetailsForm currentUser={currentUser}/>
                //</Col>
                }

                <Col sm={12} md={6}>
                    <UserDetailsPasswordForm/>
                </Col>
            </Row>
        </Page>
    )

};
export default CurrentUserPage;
